import { orderDetailOptionType } from "../recoil/cart";
import Axios, { Response } from "../util/Axios";

export type MapType = {
  left: MapStoreType[];
  right: MapStoreType[];
};

export type MapStoreType = {
  address1: string;
  address2: string;
  bearing?: number;
  bearing_type?: string;
  city: null;
  favorites_flag?: number;
  convert_bearing?: number;
  distance: number;
  is_mega_store?: number;
  last_updated_at?: string;
  lat: number;
  left_angle?: number;
  lng: number;
  order_time: number;
  pause: number;
  phone_number: string;
  pickup_type: number;
  right_angle?: number;
  store_id: number;
  store_name: string;
  store_pickup_type: string;
  store_status: string;
  store_type_code: string;
  parent_store_type_id: number;
  url_path?: string;
};

export type StoreType = {
  all: CategoryType[];
  extra: storeExtraType;
  main: MainCategoryType;
  favorites_flag: number;
  parking_image_multi: string;
  store_availability: string;
  store_availability_msg: string;
  store_coupons: any[];
  store_distance: string;
  store_extra: any;
  store_images: any;
  store_is_throo_now: number;
  store_lat: string;
  store_lng: string;
  store_name: string;
  store_notifications: StoreNotificationType[];
  store_nreview: number | null;
  store_openingclosing: string;
  store_order_time: number;
  store_order_time_nrm: string;
  store_parking_image: string;
  store_parking_image_multi: string;
  store_parking_time: string;
  store_phone_number: string;
  store_pickup_type: number;
  store_review_count: number;
  store_stamp: any[];
  user_arrival: number;
  user_arrival_show: string;
  congestion_type_name: string;
};
export type storeExtraType = {
  address1: string;
  address2: string;
  business_number: string;
  city: string;
  description: string;
  description_extra: string;
  description_holiday: string;
  description_noti: string;
  first_name: string;
  full_name: string;
  last_name: string;
  parking_pan: string;
  parking_tilt: string;
  parking_zoom: number;
  phone_number: string;
  postcode: string;
  province: string;
  store_id: number;
  trademark_name: string;
};
export type StoreNotificationType = {
  all_content: string;
  content: string;
  title: string;
  type: string;
};

export type MainCategoryType = {
  category_id: number;
  category_name: string;
  data: ProductType[];
};
export type CategoryType = {
  category_id: number;
  category_name: string;
  category_store_confirmed: number;
  product_list: ProductType[];
};
export type ProductType = {
  store_id?: number;
  amount?: number;
  is_soldout: number;
  is_throo_only: number;
  option_id: number;
  oSelectedOptions?: orderDetailOptionType[];
  options: any[];
  prd_base_price: string;
  prd_base_price_nrm: string;
  prd_base_price_option: string;
  prd_base_price_option_nrm: string;
  prd_description: string;
  prd_discount_direction: string;
  prd_discount_percentage: number;
  prd_discount_percentage_nrm: string;
  prd_id: number;
  prd_name: string;
  prd_name2: null;
  prd_name_truncated: string;
  prd_name_truncated_long: string;
  prd_org_price: string;
  prd_org_price_nrm: string;
  url_path: string;
  url_path_big: string;
};
export type ProductOptionType = {
  image_album: string[];
  image_main_size: any;
  options: object;
  store_availability: string;
  store_availability_msg: string;
  store_data: object;
  success: boolean;
};
export type OptionType = {
  option_id: number;
  option_id_order: number;
  option_input_max: number;
  option_input_min: number;
  option_input_type: string;
  option_is_default: number;
  option_name: string;
  option_name2: string | null;
  option_prd_id: number;
  option_price: string;
  option_price_nrm: string;
  option_required: false;
  option_sold: string;
  option_type_code: string;
  option_type_id: number;
  option_type_name: string;
  option_type_name2: string | null;
  option_type_order: number;
};

export type StoreStampType = {
  category_stamp: string;
  collected_stamp: number;
  completion_value: number;
  date_value: number;
  minimum_amount: string;
  // stamp_coupon: userCouponType[];
  stamp_coupon_id: number;
  stamp_id: number;
  start_date: string;
  title: string;
};
export type StoreCouponType = {
  user_coupon_id: number;
  coupon_id: number;
  name: string;
  percent: string;
  price: string;
  type_id: number;
  start_date: string;
  end_date: string;
  max_discount: string;
  requirement: string;
  parent_coupon_id: number;
  condition: number;
  expired: number;
  store_id: number;
  used_packaged_coupon: number;
  expire_date: string;
  show_name: string;
  show_content: string;
  show_date: string;
  requirement_msg: string;
};

export type storeImageType = {
  img_detail_album: any[];
  img_detail_thumb: string;
  img_main_size: imageSizeType;
};
export type imageSizeType = {
  height: number;
  width: number;
};

export type CurrentOrderType = {
  aPrdData: ProductType[];
  iOrderId: number;
  oStoreData: CurrentOrderStoreType;
  sOrderDateShow: string;
  sOrderName: string;
  sPaymentMethod: string;
  sStateCode: string;
};
export type CurrentOrderStoreType = {
  can_order: boolean;
  distance: number;
  favorites_flag: number;
  location: { latitude: string; longitude: string };
  order_time: number;
  store_availability: string;
  store_availability_msg: string;
  store_id: number;
  store_name: string;
};

export type RecommendStoreType = {
  index: number;
  store_id: string;
  store_name: string;
  recommed_reason: string;
  distance: number;
  store_type_code: string;
  url_path: string;
};

const StoreController = {
  getList: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/store/getList";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[매장리스트 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getMainOrderNStores: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + "/obigo/store/getMainOrderNStores";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[최근주문/추천매장 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getMainList: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/store/getMainList";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[매장리스트 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getMenu: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/store/getMenu";

      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[매장정보 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getOptions: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/obigo/store/getOptions`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[옵션 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  setFavoritesStore: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/store/setFavoritesStore`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[즐겨찾기 설정 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getFavoritesStore: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/store/getFavoritesStore`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[즐겨찾기 호출 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  aiStoreRecommend: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/store/aiStoreRecommend`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[ai 답변 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
export default StoreController;
